import React from 'react';
import { Stack, LoadingIcon } from 'basis';
import { LayoutPage } from 'components';
import { CountryCode, Routes } from 'types';
import { useAppContext } from "../../hooks";
import { useGreenId } from 'hooks/useGreenId';
import { LimitedWidth } from 'components/layout-page/LimitedWidth';
import { AchError } from './AchError';


export const AchGreenIdVerification: React.FC = () => {
  const { state } = useAppContext();

  const { isLoading, error, elementId } = useGreenId({
    dev: process.env.REACT_APP_ENV !== 'prod' && state.dev,
    successRedirectPath: Routes.achSubmitted,
    cancelRedirectPath: state.countryCode === CountryCode.NZ ? Routes.achDocUpload : Routes.achSubmitted,
    lockedOutRedirectPath: state.countryCode === CountryCode.NZ ? Routes.achDocUpload : null,
    countryCode: state.countryCode,
  });

  if (state.error || error) {
    return (
      <AchError error={error} />
    );
  }

  return (
    <LayoutPage step="update" hideProgressStepper>
      {/* Green ID dropdown menu has a hardcoded max-width of 768px */}
      <LimitedWidth style={{ maxWidth: '768px' }}>
        <Stack gap="8">
          {isLoading &&
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
              <LoadingIcon size="medium" testId="loading-icon" />
            </div>
          }

          <div id={elementId}></div>
        </Stack>
      </LimitedWidth>
    </LayoutPage>
  );
};
